import api from 'api';

export const loadCountries = api('GET /api/country-groups/fields/countries');
